import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  withStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withUserProfile } from "../../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
const styles = (theme) => ({
  dialogTitle: {
    padding: 8,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    paddingLeft: 24,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialog: {
    padding: 0,
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    minWidth: "80%",
    maxWidth: "80%",
    height: "100%",
  },
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  closeButton: {
    color: theme.iconColor,
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
    top: "19px",
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, headerActions, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      classes={{ root: classes.dialogTitle }}
      {...other}
    >
      <Typography variant="h6" className={classes.title}>
        {children}
      </Typography>
      <div className={classes.headerActions}>
        {headerActions}
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  );
});

const Modal = (props) => {
  const { handleClose, classes, open, title, children, dialogClasses, disableEnforceFocus = false, headerActions } = props;
  const { theme } = props.userData.userProfile || {};
  return (
    <Dialog
      maxWidth="lg"
      aria-labelledby="dialog-title"
      open={open}
      classes={{ paper: dialogClasses ?? classes.dialog , root: classes.root}}
      className={theme}
      disableEnforceFocus={disableEnforceFocus}
    >
      <DialogTitle id="dialog-title" onClose={handleClose} headerActions={headerActions}>
        {title}
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default compose(withUserProfile, withStyles(styles))(Modal);
